import { render, staticRenderFns } from "./_anlaysis-area.vue?vue&type=template&id=1947a633&scoped=true"
import script from "./_anlaysis-area.vue?vue&type=script&lang=js"
export * from "./_anlaysis-area.vue?vue&type=script&lang=js"
import style0 from "./_anlaysis-area.vue?vue&type=style&index=0&id=1947a633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947a633",
  null
  
)

export default component.exports